<template>
  <div>
    <img src="@/assets/overdue.png" alt="">
    <p>您当前查看的调研问卷已过期</p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      src: '',
      text: ''
    };
  },
  components: {},
  watch: {},
  computed: {},
  methods: {},
  created () { },
  beforeDestroy () { }
};
</script>

<style scoped lang="less">
img {
  display: block;
  width: 6.5rem;
  margin: auto;
  margin-top: 3.67rem;
  margin-bottom: 0.53rem;
}
p {
  font-size: 0.5rem;
  color: rgb(197, 197, 197);
  text-align: center;
  margin-top: 1rem;
}
</style>
